import React, { FC } from 'react';

import MeuConsumptionComponent from './MeuConsumption';

const MeuConsumption: FC = () => {
  return <MeuConsumptionComponent />;
};
export default MeuConsumption;
